export default {
    
    index(params) {
        return window.axios.get('/api/comments', {params});
    },

    store (comment) {
        return window.axios.post('/api/comments', comment);
    },

    update(comment) {
        return window.axios.put(`/api/comments/${comment.id}`, comment);
    },

    delete(comment) {
        return window.axios.delete('/api/comments/' + comment.id);
    }

};



// WEBPACK FOOTER //
// ./resources/assets/js/services/CommentsService.js